import sm from './structureMethods-helper'

export default {

  // 회원 목록
  member_user_filter_data: [
    {
      title: '가입일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '지역',
      type: 'region',
      options: {
        sido: [],
        sigungu: [],
        dong: []
      },
      tip: '회원 주소지를 기반으로 필터할 수 있습니다.'
    },
    {
      title: '성별',
      key: 'gender',
      type: 'dropdown'
    },
    {
      title: '가입종류',
      key: 'joined_type',
      type: 'dropdown'
    },
    {
      title: '배대지 구분',
      type: 'radiobutton',
      key: 'country',
      value: null,
      options:[
        {label: '전체', value:null},
        {label: '독일', value:'de'},
        {label: '프랑스', value:'fr'}
      ]
    },
    {
      title: '파트너 담당자 여부',
      type: 'radiobutton',
      key: 'is_normal',
      value: null,
      options:[
        {label: '전체', value:null},
        {label: '일반 회원', value:true},
        {label: '파트너 담당자', value:false}
      ]
    },
    {
      title: '회원등급',
      key: 'grade',
      type: 'dropdown',
      options: [],
      tip: '일반 등급 외 다양한 회원 등급 세분화는 플러그인 설치가 필요합니다.'
    },
    {
      title: '수신 동의',
      key: 'agreement',
      type:  'agreement'
    },
    {
      title: '통합검색',
      type: 'search',
      options: sm.options([
        ['전체', 'all'],
        ['이름', 'name'],
        ['연락처', 'phone'],
        ['이메일', 'email'],
        ['회원번호', 'user_num']
      ])
    },
  ],

  member_user_table_data: sm.tableData([
    ['index', 'index', 68],
    ['created_time', '가입일', 120],
    ['country', '배대지', 150],
    ['name', '회원명', 100],
    ['phone', '휴대전화번호', 150],
    ['user_num', '회원번호', 100],
    ['email', '이메일', 180],
    /*['login_type', '가입경로', 95],*/
    /*['partner', '파트너 담당자', 125],*/
    /*['gender', '성별', 75],*/
    //['address', '주소', 200],
    // ['call_count', '전화연결 수', 100],
    ['modify_delete', '수정/삭제', 125]
  ]),

  lp_member_user_filter_data: [
    {
      title: '가입일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '가입경로',
      type: 'dropdown',
      key: 'channel',
    },
    {
      title: '유료회원',
      type: 'radiobutton',
      key: 'paid',
      value: null,
      options:[
        {label: '전체', value:null},
        {label: '일반 회원', value:false},
        {label: '유료 회원', value:true}
      ]
    },
    {
      title: '개설한 서비스',
      type: 'radiobutton',
      key: 'service_isnull',
      value: null,
      options:[
        {label: '전체', value:null},
        {label: '없음', value:true},
        {label: '있음', value:false}
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: sm.options([
        ['전체', 'all'],
        ['이름', 'name'],
        ['연락처', 'phone'],
        ['이메일', 'email'],
        ['아이디', 'username']
      ])
    },
  ],

  lp_member_user_table_data: sm.tableData([
    ['index', 'index', 68],
    ['created_time', '가입일', 120],
    ['guest', '회원여부', 98],
    ['paid_user', '유료회원', 98],
    ['service_count', '개설한 서비스', 128],
    ['name', '회원명', 90],
    ['phone', '휴대전화번호', 150],
    ['email', '이메일', 180],
    ['channel', '가입경로', 95],
    ['partner', '개발자 계정', 125],
    ['partner_name', '소속 파트너', 125],
    ['auth_type', '인증구분', 100],
    ['modify_delete', '수정/삭제', 125]
  ]),

  // 회원 맞춤 DB
  user_param_filter_data: [
    {
      title: '맞춤DB 등록일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: 'DB 이름', value: 'name' }
      ]
    }
  ],

  user_param_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '맞춤DB 등록일', 150],
    ['name', '이름', 150],
    ['param_type', '맞춤DB 타입', 150],
    ['choice_items', '선택형 선택지', 150],
    ['modify_delete', '수정/삭제', 125]
  ]),


  // 파트너 목록
  partner_filter_data: [
    {
      title: '등록일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '카테고리',
      type: 'category',
      options: {
        category1: [],
        category2: [],
        category3: []
      },
      tip: '카테고리별로 상품을 보유한 파트너만 조회할 수 있습니다.'
    },
    {
      title: '서비스 가능 지역',
      type: 'region',
      options: {
        sido: [],
        sigungu: [],
        dong: []
      }
    },
    {
      title: '서비스 가능 지역 등록여부',
      type: 'radiobutton',
      key: 'able_address',
      value: null,
      options:[
        {label: '전체', value:null},
        {label: '등록안함', value: true},
        {label: '등록함', value: false}
      ]
    },
    {
      title: '파트너 구분',
      type: 'radiobutton',
      key: 'partner_type',
      value: null,
      options:[
        {label: '전체', value:null},
        {label: '일반파트너', value: 1},
        {label: '제휴파트너', value: 0}
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        {label: '전체', value: 'all'},
        {label: '이름', value: 'name'},
        {label: '연락처', value: 'phone'},
        {label: '이메일', value: 'email'},
        {label: '아이디', value: 'username'}
      ]
    }
  ],

  partner_table_data: sm.tableData(
    [
      ['index', 'index', 65],
      ['created_time', '등록일', 120],
      ['partner_type', '파트너 구분', 110],
      ['name', '파트너명', 100],
      ['phone', '파트너 연락처', 125],
      ['first_img', '대표 이미지', 120],
      ['partner_admin_name', '대표 관리자 이름', 150],
      ['partner_admin_email', '대표 관리자 이메일', 170],
      ['partner_admin_phone', '대표 관리자 연락처', 170],
      ['address', '주소', 200],
      ['phone', '파트너 연락처', 125],
      ['product_count', '상품 수', 90],
      ['modify_delete', '수정/삭제', 125]
    ]
  ),

  space_partner_filter_data: [
    {
      title: '등록일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '카테고리',
      type: 'category',
      options: {
        category1: [],
        category2: [],
        category3: []
      },
      tip: '카테고리별로 상품을 보유한 공간 파트너만 조회할 수 있습니다.'
    },
    {
      title: '서비스 가능 지역',
      type: 'region',
      options: {
        sido: [],
        sigungu: [],
        dong: []
      }
    },
    {
      title: '서비스 가능 지역 등록여부',
      type: 'radiobutton',
      key: 'able_address',
      value: null,
      options:[
        {label: '전체', value:null},
        {label: '등록안함', value: true},
        {label: '등록함', value: false}
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        {label: '전체', value: 'all'},
        {label: '이름', value: 'name'},
        {label: '연락처', value: 'phone'},
        {label: '이메일', value: 'email'},
        {label: '아이디', value: 'username'}
      ]
    }
  ],
  space_partner_table_data: sm.tableData(
    [
      ['index', 'index', 65],
      ['created_time', '등록일', 120],
      ['name', '파트너명', 100],
      ['phone', '파트너 연락처', 125],
      ['first_img', '대표 이미지', 120],
      ['partner_admin_name', '대표 관리자 이름', 150],
      ['partner_admin_email', '대표 관리자 이메일', 170],
      ['partner_admin_phone', '대표 관리자 연락처', 170],
      ['address', '주소', 200],
      ['phone', '파트너 연락처', 125],
      ['product_count', '공간 수', 120],
      ['modify_delete', '수정/삭제', 125]
    ]
  ),

  // 상품 목록
  product_filter_data: [
    {
      title: '상품등록일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '카테고리',
      type: 'category',
      options: {
        category1: [],
        category2: [],
        category3: []
      }
    },
    {
      title: '판매가',
      type: 'price',
      list: [
        {
          key: 'min_price',
          value: ''
        },
        {
          key: 'max_price',
          value: ''
        }
      ]
    },
    {
      title: '노출여부',
      type: 'radiobutton',
      key: 'enable_prod',
      value: null,
      options:[
        {label: '전체', value:null},
        {label: '노출', value:'true'},
        {label: '비노출', value:'false'}
      ]
    },
    {
      title: '서비스 가능 지역',
      type: 'region',
      options: {
        sido: [],
        sigungu: [],
        dong: []
      }
    },
    /*{
      title: '상품 종류',
      key: 'package',
      type: 'dropdown',
      options: []
    },*/
    {
      title: '통합검색',
      type: 'search',
      options: [
        {label: '전체', value: 'all'},
        {label: '파트너명', value: 'partner'},
        {label: '상품명', value: 'product'},
        {label: '상품 ID', value: 'id'},
        {label: '상품코드', value: 'code'},
      ]
    }
  ],

  product_table_data: sm.tableData([
    ['index', 'index', 65],
    ['id', 'ID', 65],
    ['created_time', '상품등록일', 120],
    ['is_exposure', '노출여부', 80, false],
    ['status', '승인여부', 100],
    ['category', '카테고리', 100, false],
    ['partner.name', '파트너명', 100],
    ['first_img', '대표 이미지', 120, false],
    ['name', '상품명', 104],
    ['package', '상품종류', 100],
    ['is_simple', '일반상품', 100, false],
    ['price', '판매가/기준', 120],
    ['visit', '조회', 80],
    ['review_count', '리뷰', 80, false],
    ['modify_delete', '수정/삭제', 125, false]
  ]),

  // 상품 맞춤 DB
  product_param_filter_data: [
    {
      title: '맞춤DB 등록일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: 'DB 이름', value: 'name' }
      ]
    }
  ],

  product_param_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '맞춤DB 등록일', 150],
    ['name', '이름', 150],
    ['param_type', '맞춤DB 타입', 150],
    ['choice_items', '선택형 선택지', 150],
    ['modify_delete', '수정/삭제', 125]
  ]),

  // 상품 목록
  space_product_filter_data: [
    {
      title: '상품등록일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '카테고리',
      type: 'category',
      options: {
        category1: [],
        category2: [],
        category3: []
      }
    },
    {
      title: '판매가',
      type: 'price',
      list: [
        {
          key: 'min_price',
          value: ''
        },
        {
          key: 'max_price',
          value: ''
        }
      ]
    },
    {
      title: '노출여부',
      type: 'radiobutton',
      key: 'enable_prod',
      value: null,
      options:[
        {label: '전체', value:null},
        {label: '노출', value:'true'},
        {label: '비노출', value:'false'}
      ]
    },
    {
      title: '서비스 가능 지역',
      type: 'region',
      options: {
        sido: [],
        sigungu: [],
        dong: []
      }
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        {label: '전체', value: 'all'},
        {label: '파트너명', value: 'partner'},
        {label: '상품명', value: 'product'},
        {label: '상품코드', value: 'code'},
      ]
    }
  ],

  space_product_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '상품등록일', 120],
    ['is_exposure', '노출여부', 80, false],
    ['category', '카테고리', 100, false],
    ['partner.name', '파트너명', 100],
    ['first_img', '대표 이미지', 120, false],
    ['name', '상품명', 104],
    ['is_simple', '일반상품', 100, false],
    ['price', '판매가/기준', 120],
    ['visit', '조회', 80],
    ['review_count', '리뷰', 80, false],
    ['modify_delete', '수정/삭제', 125, false]
  ]),

  // 상품 맞춤 DB
  space_product_param_filter_data: [
    {
      title: '맞춤DB 등록일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: 'DB 이름', value: 'name' }
      ]
    }
  ],

  space_product_param_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '맞춤DB 등록일', 150],
    ['name', '이름', 150],
    ['param_type', '맞춤DB 타입', 150],
    ['choice_items', '선택형 선택지', 150],
    ['modify_delete', '수정/삭제', 125]
  ]),

  // 상품후기 - 신규내역
  product_review_new_filter_data: [
    {
      title: '작성일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '카테고리',
      type: 'category',
      options: {
        category1: [],
        category2: [],
        category3: []
      }
    },
    {
      title: '답변여부',
      type: 'radiobutton',
      key: 'reply',
      value: "true",
      options: [
        { label: "전체", value: null },
        { label: "완료", value: "false" },
        { label: "대기", value: "true" }
      ]
    },
    {
      title: '첨부이미지 여부',
      type: 'radiobutton',
      key: 'imgs',
      value: null,
      options: [
        { label: "전체", value: null },
        { label: "있음", value: "false" },
        { label: "없음", value: "true" }
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: "전체", value: "all" },
        { label: "제목", value: "title" },
        { label: "상품명", value: "product" },
        { label: "글내용", value: "content" },
        { label: "작성자id", value: "writer_id" },
        { label: "작성자이름", value: "writer_name" }
      ]
    },
  ],

  product_review_new_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '작성일', 120],
    ['product', '상품명', 104],
    ['first_img', '이미지', 84],
    ['author', '작성자', 80],
    ['title', '제목', 140],
    ['rate', '평점', 80],
    ['comment_status', '답변 상태', 140],
    ['answerer', '답변자', 120],
    ['comment_reg', '답변하기', 140],
    ['delete', '삭제', 100]
  ]),

  // 상품후기 - 전체내역
  product_review_all_filter_data: [
    {
      title: '작성일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '카테고리',
      type: 'category',
      options: {
        category1: [],
        category2: [],
        category3: []
      }
    },
    {
      title: '답변여부',
      type: 'radiobutton',
      key: 'reply',
      options: [
        { label: "전체", value: "" },
        { label: "완료", value: "false" },
        { label: "대기", value: "true" }
      ]
    },
    {
      title: '첨부이미지 여부',
      type: 'radiobutton',
      key: 'imgs',
      value: null,
      options: [
        { label: "전체", value: null },
        { label: "있음", value: "false" },
        { label: "없음", value: "true" }
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: "전체", value: "all" },
        { label: "제목", value: "title" },
        { label: "상품명", value: "product" },
        { label: "글내용", value: "content" },
        { label: "작성자id", value: "writer_id" },
        { label: "작성자이름", value: "writer_name" }
      ]
    },
  ],

  product_review_all_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '작성일', 120],
    ['product', '상품명', 104],
    ['img', '이미지', 84],
    ['author', '작성자', 80],
    ['title', '제목', 140],
    ['rate', '평점', 80],
    ['comment_status', '답변 상태', 140],
    ['answerer', '답변자', 120],
    ['comment_reg', '답변하기', 140],
    ['delete', '삭제', 100]
  ]),

  // 상품문의 - 신규내역
  product_inquiry_new_filter_data: [
    {
      title: '작성일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '카테고리',
      type: 'category',
      options: {
        category1: [],
        category2: [],
        category3: []
      }
    },
    {
      title: '게시물 확인상태',
      type: 'radiobutton',
      key: 'is_checked',
      value: 'false',
      options: [
        { label: "전체", value: null },
        { label: "확인", value: "true" },
        { label: "미확인", value: "false" }
      ]
    },
    {
      title: '답변여부',
      type: 'radiobutton',
      key: 'is_answered',
      value: 'true',
      options: [
        { label: "전체", value: null },
        { label: "완료", value: "false" },
        { label: "대기", value: "true" }
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: "전체", value: "all" },
        { label: "제목", value: "title" },
        { label: "상품명", value: "product" },
        { label: "질문내용", value: "question_content" },
        { label: "답변내용", value: "answer_content" },
        { label: "작성자id", value: "writer_id" },
        { label: "작성자이름", value: "writer_name" }
      ]
    },
  ],

  product_inquiry_new_table_data: sm.tableData([
    [ 'index', 'index',65],
    ['created_time', '문의작성일', 120],
    ['channel', '서비스 구분', 120],
    ['product', '상품명', 104],
    ['first_img', '이미지',84],
    ['author', '작성자',80],
    ['title', '제목', 140],
    ['question_content', '내용', 140],
    ['confirm_status', '확인 상태', 150],
    ['answerer', '답변자', 100],
    ['answer_content', '답변 내용', 200],
    ['comment_status', '답변 상태', 150],
    ['comment_reg', '답변하기', 150]
  ]),

  // 상품문의 - 전체내역
  product_inquiry_all_filter_data: [
    {
      title: '작성일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '카테고리',
      type: 'category',
      options: {
        category1: [],
        category2: [],
        category3: []
      }
    },
    {
      title: '게시물 확인상태',
      type: 'radiobutton',
      key: 'is_checked',
      value: null,
      options:[
        { label: '전체', value:null },
        { label: "확인", value: "true" },
        { label: "미확인", value: "false" }
      ]
    },
    {
      title: '답변여부',
      type: 'radiobutton',
      key: 'is_answered',
      value: null,
      options:[
        {label: '전체', value:null},
        { label: "완료", value: "false" },
        { label: "대기", value: "true" }
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: "전체", value: "all" },
        { label: "제목", value: "title" },
        { label: "상품명", value: "product" },
        { label: "질문내용", value: "question_content" },
        { label: "답변내용", value: "answer_content" },
        { label: "작성자id", value: "writer_id" },
        { label: "작성자이름", value: "writer_name" }
      ]
    },
  ],

  product_inquiry_all_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '문의작성일', 120],
    ['channel', '서비스 구분', 120],
    ['product', '상품명', 104],
    ['first_img', '이미지', 84],
    ['author', '작성자', 80],
    ['title', '제목', 140],
    ['question_content', '내용', 140],
    ['confirm_status', '확인 상태', 150],
    ['answerer', '답변자', 100],
    ['answer_content', '답변 내용', 200],
    ['comment_status', '답변 상태', 150],
    ['comment_reg', '답변하기', 150]
  ]),

  // 파트너 문의
  partner_inquiry_new_filter_data: [
    {
      title: '카테고리',
      type: 'inquiry_category',
      options: {
        category1: [],
        category2: [],
        category3: []
      }
    },
    {
      title: '회원여부',
      type: 'radiobutton',
      key: 'user',
      options: [
        { label: '전체', value: '' },
        { label: '회원', value: false },
        { label: '비회원', value: true }
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        //회원 구분 / 대표자명 / 상호명 / 사업자 등록번호 로 변경
        { label: "전체", value: "all" },
        { label: "대표자명", value: "name" },
        { label: "상호명", value: "company" },
        { label: "사업자 등록번호", value: "business_num" },
        { label: "연락처", value: "phone" }
      ]
    },
  ],

  partner_inquiry_new_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '문의작성일', 120],
    ['user_type', '회원 구분', 80],
    ['category', '카테고리', 104],
    ['name', '대표자명', 80],
    ['company', '상호명', 140],
    ['business_num', '사업자 등록번호', 140],
    ['phone', '연락처', 140],
    ['confirm_status', '확인 상태', 150],
    ['modify_delete', '상세', 140]
  ]),

  // 파트너 문의
  partner_inquiry_all_filter_data: [
    {
      title: '작성일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '카테고리',
      type: 'inquiry_category',
      options: {
        category1: [],
        category2: [],
        category3: []
      }
    },
    {
      title: '회원여부',
      type: 'radiobutton',
      key: 'user',
      options: [
        { label: '전체', value: '' },
        { label: '회원', value: false },
        { label: '비회원', value: true }
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: "전체", value: "all" },
        { label: "대표자명", value: "name" },
        { label: "상호명", value: "company" },
        { label: "사업자 등록번호", value: "business_num" },
        { label: "연락처", value: "phone" }

      ]
    },
  ],

  partner_inquiry_all_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '문의작성일', 120],
    ['user_type', '회원 구분', 100],
    ['category', '카테고리', 104],
    ['name', '대표자명', 130],
    ['company', '상호명', 140],
    ['business_num', '사업자 등록번호', 140],
    ['phone', '연락처', 140],
    ['confirm_status', '확인 상태', 150],
    ['modify_delete', '상세', 140]
  ]),

  // 1:1문의 - 신규내역
  onetoone_new_filter_data: [
    {
      title: '작성일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '문의 카테고리',
      type: 'one_category',
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: "전체", value: "all" },
        { label: "제목", value: "title" },
        { label: "질문내용", value: "content" },
        { label: "답변내용", value: "answer_content" },
        { label: "작성자이름", value: "name" },
        { label: "전화번호", value: "phone" },
        { label: "이메일", value: "email" },
      ]
    },
  ],

  onetoone_new_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '문의작성일', 120],
    ['country', '배대지', 100],
    ['user_type', '회원구분', 100],
    ['type', '문의유형', 104],
    ['imgs', '첨부파일', 100],
    ['name', '작성자', 80],
    ['title', '제목', 140],
    ['content', '내용', 140],
    ['confirm_status', '확인 상태', 120],
    ['answer_content', '답변 내용', 200],
    ['comment_status', '답변 상태', 150]
  ]),

  // 1:1문의 - 전체내역
  onetoone_all_filter_data: [
    {
      title: '작성일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '문의 카테고리',
      type: 'one_category',
    },
    {
      title: '게시물 확인상태',
      type: 'radiobutton',
      key: 'is_new',
      value: null,
      options:[
        { label: '전체', value:null },
        { label: "확인", value: "true" },
        { label: "미확인", value: "false" }
      ]
    },
    {
      title: '답변여부',
      type: 'radiobutton',
      key: 'is_answered',
      value: null,
      options:[
        { label: '전체', value:null },
        { label: "완료", value: "true" },
        { label: "대기", value: "false" }
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: "전체", value: "all" },
        { label: "제목", value: "title" },
        { label: "질문내용", value: "content" },
        { label: "답변내용", value: "answer_content" },
        { label: "작성자이름", value: "name" },
        { label: "전화번호", value: "phone" },
        { label: "이메일", value: "email" },
      ]
    },
  ],

  onetoone_all_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '문의작성일', 120],
    ['country', '배대지', 100],
    ['user_type', '회원구분', 100],
    ['type', '문의유형', 104],
    ['imgs', '첨부파일', 100],
    ['name', '작성자', 80],
    ['title', '제목', 140],
    ['content', '내용', 140],
    ['confirm_status', '확인 상태', 120],
    ['answer_content', '답변 내용', 200],
    ['comment_status', '답변 상태', 150]
  ]),

  // 오늘 전화 연결 내역
  call_new_filter_data: [
    {
      title: '회원구분',
      type: 'radiobutton',
      key: 'user',
      value: null,
      options:[
        { label: '전체', value:null },
        { label: '회원', value: 'false' },
        { label: '비회원', value: 'true' }
      ]
    },
    {
      title: '발신일',
      type: 'period',
      start: '',
      end: '',
    },
    {
      title: '발신시각',
      type: 'time',
    },
    {
      title: '통합조회',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '회원명', value: 'name' },
        { label: '이메일', value: 'email' },
        { label: '휴대전화번호', value: 'phone' },
        { label: '이메일파트너명', value: 'partner' },
      ]
    },
  ],

  call_new_table_data: sm.tableData([
    ['index', 'index', 65],
    ['date', '발신일', 100],
    ['time', '발신시각', 100],
    ['user', '회원여부', 100],
    ['name', '회원명', 100],
    ['username', '회원이메일(아이디)', 160],
    ['phone', '휴대전화번호', 125],
    ['partner', '파트너명', 100],
    ['product', '상품명', 100],
    ['call_detail', '상담/주문 내용등록', 160]
  ]),

  // 오늘 전화 상담/주문 내역
  call_order_new_filter_data: [
    {
      title: '발신일',
      type: 'period',
      start: '',
      end: '',
    },
    {
      title: '발신시각',
      type: 'time',
    },
    /*{
      title: '회원여부',
      type: 'radiobutton',
      key: 'is_guest',
      options: [
        { label: '전체', value: '' },
        { label: '회원', value: 'false' },
        { label: '비회원', value: 'true' }
      ]
    },*/
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '회원명', value: 'name' },
        { label: '이메일', value: 'email' },
        { label: '휴대전화번호', value: 'phone' },
        { label: '상담내용', value: 'counsel_content' },
        { label: '주문내용', value: 'order_content' },
      ]
    },
  ],

  call_order_new_table_data: sm.tableData([
    ['index', 'index', 65],
    ['date', '등록일', 100],
    ['time', '등록시각', 100],
    ['is_guest', '회원여부', 100],
    ['name', '이름', 100],
    ['phone', '연락처', 125],
    ['username', '이메일', 160],
    ['counsel_content', '상담내용', 130],
    ['call_detail', '상세', 160]
  ]),


  // 전체 전화 상담/주문 내역
  call_order_all_filter_data: [
    {
      title: '발신일',
      type: 'period',
      start: '',
      end: '',
    },
    {
      title: '발신시각',
      type: 'time',
    },
    /*{
      title: '회원여부',
      type: 'radiobutton',
      key: 'is_guest',
      options: [
        { label: '전체', value: '' },
        { label: '회원', value: 'false' },
        { label: '비회원', value: 'true' }
      ]
    },*/
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '회원명', value: 'name' },
        { label: '이메일', value: 'email' },
        { label: '휴대전화번호', value: 'phone' },
        { label: '상담내용', value: 'counsel_content' },
        { label: '주문내용', value: 'order_content' },
      ]
    },
  ],

  call_order_all_table_data: sm.tableData([
    ['index', 'index', 65],
    ['date', '등록일', 100],
    ['time', '등록시각', 100],
    ['is_guest', '회원여부', 100],
    ['name', '회원명', 100],
    ['username', '회원이메일(아이디)', 160],
    ['phone', '휴대전화번호', 125],
    /*['partnername', '파트너명', 100],*/
    ['counsel_content', '상담내용', 130],
    ['order', '주문여부', 100],
    ['order_content', '주문내용', 130],
    ['call_detail', '상담/주문 내용등록', 160]
  ]),

  // 공지사항 목록
  notice_filter_data: [
    {
      title: '게시글 작성일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: "전체", value: "all" },
        { label: "제목", value: "title" },
        { label: "내용", value: "content" }
      ]
    }
  ],

  notice_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '게시글 작성일', 140],
    ['title', '제목', 100],
    ['hits', '조회수', 100],
    ['comment_count', '댓글수', 100],
    ['priority', '노출 우선순위', 140],
    ['modify_delete', '수정/삭제', 125]
  ]),

  // FAQ 목록
  faq_filter_data: [
    {
      title: '게시글 작성일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: "전체", value: "all" },
        { label: "제목", value: "title" },
        { label: "내용", value: "content" }
      ]
    }
  ],

  faq_table_data: sm.tableData([
    ['index', 'index',65],
    ['created_time', '게시글 작성일', 140],
    ['question', '질문', 100],
    ['answer', '답변', 100],
    ['hits', '조회수', 100],
    ['priority', '노출 우선순위', 100],
    ['modify_delete', '수정/삭제', 125]
  ]),

  // 이벤트 목록
  event_filter_data: [
    {
      title: '게시글 작성일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: "전체", value: "all" },
        { label: "제목", value: "title" },
        { label: "내용", value: "content" }
      ]
    }
  ],

  event_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '게시글 작성일', 140],
    ['title', '제목', 120],
    ['hits', '조회수', 100],
    ['comment_count', '댓글수', 100],
    ['priority', '노출 우선순위', 100],
    ['modify_delete', '수정/삭제', 125]
  ]),

  // 기획전 목록
  exhibition_filter_data: [
    {
      title: '기획전 등록일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '노출 여부',
      type: 'radiobutton',
      key: 'display_type',
      value: '0',
      options: [
        { label: '노출', value: '0' },
        { label: '기간별 노출', value: '1' },
        { label: '노출안함', value: '2' }
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: "전체", value: "all" },
        { label: "제목", value: "title" },
        { label: "내용", value: "content" }
      ]
    }
  ],

  exhibition_table_data: sm.tableData([
    ['index', 'index', 65],
    ['title', '제목', 100],
    ['created_time', '기획전 등록일', 140],
    ['display_type', '노출 여부', 100],
    ['start_date', '노출 시작', 100],
    ['end_date', '노출 종료', 100],
    ['img', '이미지', 100],
    ['desc', '설명', 152],
    ['product_list', '연관된 상품', 240],
    ['modify_delete', '수정/삭제', 125]
  ]),

  // 파트너 기획전 목록
  exhibition_partner_filter_data: [
    {
      title: '파트너 기획전 등록일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '노출 여부',
      type: 'radiobutton',
      key: 'display_type',
      value: '0',
      options: [
        { label: '노출', value: '0' },
        { label: '기간별 노출', value: '1' },
        { label: '노출안함', value: '2' }
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: "전체", value: "all" },
        { label: "제목", value: "title" },
        { label: "내용", value: "content" }
      ]
    }
  ],

  exhibition_partner_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '파트너 기획전 등록일', 140],
    ['display_type', '노출 여부', 100],
    ['start_date', '노출 시작', 100],
    ['end_date', '노출 종료', 100],
    ['img', '이미지', 100],
    ['title', '제목', 100],
    ['desc', '설명', 152],
    ['partner_list', '연관된 파트너', 150],
    ['modify_delete', '수정', 125]
  ]),

  // 파트너별 상품 기획전 목록
  exhibition_partner_product_filter_data: [
    {
      title: '기획전 등록일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '노출 여부',
      type: 'radiobutton',
      key: 'display_type',
      value: '0',
      options: [
        { label: '노출', value: '0' },
        { label: '기간별 노출', value: '1' },
        { label: '노출안함', value: '2' }
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: "전체", value: "all" },
        { label: "제목", value: "title" },
        { label: "내용", value: "content" }
      ]
    }
  ],

  exhibition_partner_product_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '기획전 등록일', 140],
    ['display_type', '노출 여부', 100],
    ['start_date', '노출 시작', 100],
    ['end_date', '노출 종료', 100],
    ['img', '이미지', 100],
    ['title', '제목', 100],
    ['desc', '설명', 152],
    ['partner_list', '연관된 파트너', 150],
    ['modify_delete', '수정', 125]
  ]),

  // 배너 목록
  banner_filter_data: [
    {
      title: '배너 등록일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: "전체", value: "all" },
        { label: "제목", value: "title" },
      ]
    }
  ],

  banner_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '배너 등록일', 120],
    ['imgs', '이미지', 120],
    ['title', '제목', 100],
    ['start_date', '노출 시작', 100],
    ['end_date', '노출 종료', 100],
    ['modify_delete', '수정/삭제', 125]
  ]),

  // 팝업 목록
  popup_filter_data: [
    {
      title: '팝업 등록일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: "전체", value: "all" },
        { label: "제목", value: "title" },
      ]
    }
  ],

  popup_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '팝업 등록일', 120],
    ['title', '제목', 100],
    ['start_date', '노출 시작', 100],
    ['end_date', '노출 종료', 100],
    ['modify_delete', '수정/삭제', 125]
  ]),

  // 서비스 가이드
  guide_filter_data: [
    {
      title: '서비스 가이드 등록일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: "전체", value: "all" },
        { label: "제목", value: "title" },
      ]
    }
  ],

  guide_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '서비스 가이드 등록일', 120],
    ['title', '제목', 100],
    ['visible', '노출 여부', 100],
    ['modify_delete', '수정/삭제', 125]
  ]),

  // 서비스 가이드
  push_filter_data: [
    {
      title: '기간 검색',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '전송 대상',
      type: 'radiobutton',
      key: 'target',
      value: null,
      options:[
        { label: '전체', value: null },
        { label: '일반회원', value: 0 },
        { label: '마케팅 수신 회원', value: 2 }
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: "전체", value: "all" },
        { label: "제목", value: "title" },
        { label: "내용", value: "msg" },
      ]
    }
  ],

  // 푸시 알림 목록
  push_table_data: sm.tableData([
    ['index', 'index', 60],
    ['created_time', '전송일', 140],
    ['title', '제목', 140],
    ['msg', '내용', 140],
    ['device', '기기 대상', 80],
    ['target', '전송 대상', 80]
  ]),

  // 견적요청 - 신규요청내역
  request_new_filter_data: [
    {
      title: '견적요청일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '견적요청 폼',
      key: 'estimate_form',
      type: 'dropdown',
      options: []
    },
    /*{
      title: '카테고리',
      type: 'category',
      options: {
        category1: [],
        category2: [],
        category3: []
      }
    },*/
    {
      title: '통합검색',
      type: 'search',
      options: [
        {label: '전체', value: 'all'},
        {label: '이름', value: 'name'},
        {label: '연락처', value: 'phone'},
        {label: '이메일', value: 'email'},
        {label: '아이디', value: 'username'}
      ]
    }
  ],

  request_new_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '견적 요청일', 140],
    ['name', '신청자 이름', 120],
    ['phone', '신청자 연락처', 130],
    ['email', '신청자 이메일', 140],
    ['estimate_content', '견적 요청 내용', 150],
    ['estimate_status', '견적상태', 140],
    ['estimate_button', '견적서처리', 140]
  ]),

  // 견적요청 - 전체요청내역
  request_all_filter_data: [
    {
      title: '견적요청일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '견적요청 폼',
      key: 'estimate_form',
      type: 'dropdown',
      options: []
    },
    /*{
      title: '카테고리',
      type: 'category',
      options: {
        category1: [],
        category2: [],
        category3: []
      }
    },*/
    {
      title: '통합검색',
      type: 'search',
      options: [
        {label: '전체', value: 'all'},
        {label: '이름', value: 'name'},
        {label: '연락처', value: 'phone'},
        {label: '이메일', value: 'email'},
        {label: '아이디', value: 'username'}
      ]
    }
  ],

  request_all_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '견적 요청일', 140],
    ['name', '신청자 이름', 120],
    ['phone', '신청자 연락처', 130],
    ['email', '신청자 이메일', 140],
    ['estimate_content', '견적 요청 내용', 150],
    ['estimate_status', '견적상태', 140],
    ['estimate_button', '견적서처리', 140]
  ]),

  // 견적요청 - 파트너의뢰내역
  request_partner_filter_data: [
    {
      title: '의뢰 요청일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '이름', value: 'name' },
        { label: '파트너 이름', value: 'partner' },
        { label: '전화번호', value: 'phone' },
        { label: '이메일', value: 'email' }
      ]
    }
  ],

  request_partner_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '의뢰 요청일', 120],
    ['partner', '파트너 이름', 120],
    ['estimate_content', '견적 요청 내용', 100],
    ['request_partner_detail', '의뢰 상세', 100],
    ['modify_delete', '수정/삭제', 125]
  ]),

  // 견적서 내역
  response_all_filter_data: [
    {
      title: '견적 요청일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '견적요청 폼',
      key: 'estimate_form',
      type: 'dropdown',
      options: []
    },
    /*{
      title: '카테고리',
      type: 'category',
      options: {
        category1: [],
        category2: [],
        category3: []
      }
    },*/
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '이름', value: 'name' },
        { label: '연락처', value: 'phone' },
        { label: '이메일', value: 'email' },
        { label: '파트너명', value: 'partner' },
      ]
    }
  ],

  response_all_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '주문 요청일', 120],
    ['name', '신청자 이름', 110],
    ['phone', '신청자 연락처', 125],
    ['email', '신청자 이메일', 130],
    ['estimate_content', '견적 요청 내용', 150],
    ['partner_name', '파트너명', 150],
    ['response_sheet', '주문할 견적서', 150],
    ['price', '주문 금액', 110],
    ['note', '메모', 120],
    ['response_status', '진행현황', 150]
  ]),

  // 주문 내역
  order_new_filter_data: [
    {
      title: '주문 요청일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '견적요청 폼',
      key: 'estimate_form',
      type: 'dropdown',
      options: []
    },
    {
      title: '주문금액',
      type: 'price',
      list: [
        {
          key: 'min_price',
          value: ''
        },
        {
          key: 'max_price',
          value: ''
        }
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '이름', value: 'name' },
        { label: '전화번호', value: 'phone' },
        { label: '이메일', value: 'email' }
      ]
    }
  ],

  order_new_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '주문 요청일', 110],
    ['name', '신청자 이름', 110],
    ['phone', '신청자 연락처', 130],
    ['email', '신청자 이메일', 140],
    ['estimate_content', '견적 요청 내용', 130],
    ['bid_content', '주문 내역', 130],
    ['order_status', '주문상태', 130],
    ['status', '승인/거절', 150]
  ]),

  // 주문 내역
  order_all_filter_data: [
    {
      title: '주문 요청일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '견적요청 폼',
      key: 'estiate_form',
      type: 'dropdown',
      options: []
    },
    {
      title: '주문금액',
      type: 'price',
      list: [
        {
          key: 'min_price',
          value: ''
        },
        {
          key: 'max_price',
          value: ''
        }
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '이름', value: 'name' },
        { label: '전화번호', value: 'phone' },
        { label: '이메일', value: 'email' }
      ]
    }
  ],

  order_all_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '주문 요청일', 110],
    ['name', '신청자 이름', 110],
    ['phone', '신청자 연락처', 130],
    ['email', '신청자 이메일', 140],
    ['estimate_content', '견적 요청 내용', 130],
    ['bid_content', '주문 내역', 130],
    ['order_status', '주문상태', 130],
    ['status', '확정/취소', 150]
  ]),

  // 요청폼 목록
  form_filter_data: [
    {
      title: '등록일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '카테고리',
      type: 'category',
      options: {
        category1: [],
        category2: [],
        category3: []
      }
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '이름', value: 'name' },
        { label: '전화번호', value: 'phone' },
        { label: '이메일', value: 'email' }
      ]
    },
    {
      title: '발행상태',
      type: 'radiobutton',
      key: 'activate',
      value: null,
      options:[
        { label: '전체', value:null },
        { label: '발행', value: 'true' },
        { label: '미발행', value: 'false' }
      ]
    },
  ],

  form_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '등록일', 150],
    ['title', '견적요청서 이름', 150],
    ['updated_time', '최근 수정일', 150],
    ['request_summary', '견적요청서 개요', 300],
    ['request_count', '총 견적요청 개수', 150],
    ['category', '매핑된 카테고리', 150],
    ['activate', '발행상태', 110],
    ['modify_delete', '수정/삭제', 140]
  ]),


  // 상담 신청 폼 목록
  counsel_form_filter_data: [
    {
      title: '등록일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '이름', value: 'name' },
        { label: '전화번호', value: 'phone' },
        { label: '이메일', value: 'email' }
      ]
    },
    {
      title: '발행상태',
      type: 'radiobutton',
      key: 'activate',
      value: null,
      options:[
        { label: '전체', value:null },
        { label: '발행', value: 'true' },
        { label: '미발행', value: 'false' }
      ]
    },
  ],

  counsel_form_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '등록일', 150],
    ['title', '견적요청서 이름', 150],
    ['updated_time', '최근 수정일', 150],
    ['request_summary', '견적요청서 개요', 300],
    ['activate', '발행상태', 110],
    ['modify_delete', '수정/삭제', 140]
  ]),


  // 모임 참여 폼 목록
  meet_form_filter_data: [
    {
      title: '등록일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '이름', value: 'name' },
        { label: '전화번호', value: 'phone' },
        { label: '이메일', value: 'email' }
      ]
    },
    {
      title: '발행상태',
      type: 'radiobutton',
      key: 'activate',
      value: null,
      options:[
        { label: '전체', value:null },
        { label: '발행', value: 'true' },
        { label: '미발행', value: 'false' }
      ]
    },
  ],

  meet_form_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '등록일', 150],
    ['title', '견적요청서 이름', 150],
    ['updated_time', '최근 수정일', 150],
    ['request_summary', '견적요청서 개요', 300],
    ['activate', '발행상태', 110],
    ['modify_delete', '수정/삭제', 140]
  ]),

  // 일반 게시판 목록
  board_filter_data: [
    {
      title: '카테고리',
      type: 'category',
      options: {
        category1: [],
        category2: [],
        category3: []
      }
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '제목', value: 'name' }
      ]
    }
  ],

  // 일반 게시판

  board_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '등록일', 150],
    ['title', '게시판 이름', 120],
    ['permission_guest', '비회원 권한', 110],
    ['permission_user', '회원 권한', 110],
    ['permission_partner', '파트너 권한', 110],
    ['activate_board', '게시판 기능', 110],
    ['activate_category', '카테고리 기능', 130],
    ['activate_comment', '댓글 기능', 100],
    ['activate_reply', '답변 기능', 100],
    ['activate_share', '공유 기능', 100],
    ['modify_delete', '수정/삭제', 130]
  ]),

  // 게시글 목록
  post_filter_data: [
    {
      title: '등록일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '제목', value: 'title' },
        { label: '내용', value: 'content' },
        { label: '작성자', value: 'display_name' }
      ]
    }
  ],

  post_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '등록일', 150],
    ['title', '제목', 120],
    ['display_name', '작성자', 90],
    ['hits', '조회수', 80],
    ['comment_count', '댓글수', 80],
    ['priority', '우선순위', 100],
    ['modify_delete', '수정/삭제', 125]
  ]),

  // 게시글 연관 상품
  post_mapping_filter_data: [
    {
      title: '등록일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '제목', value: 'title' },
        { label: '내용', value: 'content' },
        { label: '작성자', value: 'display_name' }
      ]
    }
  ],

  post_mapping_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '등록일', 120],
    ['name', '작성자', 120],
    ['title', '제목', 120],
    ['product_list', '연관된 상품', 130],
    ['modify_delete', '수정', 125]
  ]),

  // 회원 등급 목록
  member_user_grade_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '등록일', 120],
    ['order', '등급순서', 90],
    ['name', '등급명', 120],
    ['label_type', '등급표시', 130],
    ['user_count', '회원수', 80],
    ['approval_type', '승인심사 종류', 120],
    ['is_auto_approval', '승인 방법', 120],
    ['content_form', '심사 컨텐츠', 120],
    ['service_active', '서비스 참여 기준', 130],
    ['board_active', '게시판 참여 기준', 130],
    ['register', '등록자', 80],
    ['modify_delete', '수정/삭제', 125]
  ]),

  // 등급 승인요청 목록
  member_grade_approve_new_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['index', 'index', 65],
    ['created_time', '처리일시', 120],
    ['approval_status', '승인구분', 125],
    ['name', '회원명', 90],
    ['username', '회원이메일(아이디)', 160],
    ['phone', '휴대전화번호', 125],
    ['nowgrade', '현재등급', 120],
    ['reqgrade', '요청등급', 120],
    ['approval_type', '승인심사종류', 125],
    ['content', '심사컨텐츠', 125],
    ['satisfy', '활동지수 충족여부', 160],
    ['enable_approval', '승인처리', 125]
  ]),

  // 요청폼 목록
  member_grade_approve_all_filter_data: [
    {
      title: '승인구분',
      type: 'radiobutton',
      key: 'approval_status',
      value: null,
      options:[
        { label: '전체', value:null },
        { label: '승인', value: 1 },
        { label: '미승인', value: 101 }
      ]
    },
    {
      title: '처리일시',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '승인 등급',
      key: 'approve_grade',
      type: 'dropdown',
      options: []
    },
    {
      title: '회원 조회',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '이름', value: 'name' }
      ]
    }
  ],

  // 등급 승인완료 목록
  member_grade_approve_all_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['index', 'index', 65],
    ['created_time', '처리일시', 120],
    ['approval_status', '승인구분', 125],
    ['name', '회원명', 90],
    ['username', '회원이메일(아이디)', 160],
    ['phone', '휴대전화번호', 125],
    ['nowgrade', '현재등급', 120],
    ['reqgrade', '요청등급', 120],
    ['approval_type', '승인심사종류', 125],
    ['content', '심사컨텐츠', 125],
    ['satisfy', '활동지수 충족여부', 160]
  ]),

  // 상품 등록 승인 필터
  product_approval_filter_data: [
    {
      title: '승인구분',
      type: 'radiobutton',
      key: 'status',
      value: null,
      options:[
        { label: '전체', value:null },
        { label: '미승인', value: 1 },
        { label: '승인', value: 2 },
      ]
    },
    {
      title: '처리일시',
      type: 'period',
      start: '',
      end: ''
    }
  ],

  // 상품 등록 승인 요청 목록
  product_approval_new_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['index', 'index', 65],
    ['created_time', '등록일', 150],
    ['product', '상품 이름', 100],
    ['partner', '파트너 이름', 140],
    ['product_count', '등록된 상품 수', 130],
    ['memo', '메모', 100],
    ['status', '상태', 125]
  ]),

  // 상품 등록 승인 완료 목록
  product_approval_all_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '등록일', 150],
    ['product', '상품 이름', 100],
    ['partner', '파트너 이름', 140],
    ['memo', '메모', 100],
    ['status', '상태', 125]
  ]),

  // 파트너 등급 목록
  member_partner_grade_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '등록일', 150],
    ['order', '등급순서', 100],
    ['name', '등급명', 120],
    ['label_type', '등급표시', 130],
    ['partner_count', '파트너수', 100],
    ['approval_type', '승인심사 종류', 140],
    ['content_form', '심사 컨텐츠', 120],
    ['service_active', '서비스 참여 기준', 140],
    ['board_active', '게시판 참여 기준', 140],
    ['register', '등록자', 80],
    ['modify_delete', '수정/삭제', 125]
  ]),

  launchpack_hosting_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '생성일', 130],
    ['name', '이름', 130],
    ['desc', '설명', 85],
    ['modify_delete', '상세', 230]
  ]),

  launchpack_care_service_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '생성일', 130],
    ['name', '이름', 130],
    ['price', '가격', 85],
    ['modify_delete', '상세', 230]
  ]),

  // Launchpack
  launchpack_service_filter_data: [
    {
      title: '서비스 생성일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '서비스 구분',
      type: 'radiobutton',
      key: 'service_type',
      value: null,
      options:[
        {value: null, label: '전체'},
        {value: 0, label: '퀵빌더'},
        {value: 1, label: '디자인마켓'},
        {value: 2, label: '주문제작'},
        {value: 4, label: '플랫폼파이'},
        {value: 5, label: '스킨'},
        {value: 6, label: '독립형'}
      ]
    },
    {
      title: '서비스 상태',
      type: 'radiobutton',
      key: 'status',
      value: null,
      options:[
        {value: null, label: '전체'},
        {value: 0, label: '이용 예정'},
        {value: 9, label: '이용중'},
        {value: 10, label: '관리자 정지'},
        {value: 99, label: '전체정지'},
        {value: 100, label: '이용중단'}
      ]
    },
    {
      title: '패키지',
      type: 'radiobutton',
      key: 'package',
      value: null,
      options: [
        {value: null, label: '전체'},
        {value: 'call', label: '전화연결'},
        {value: 'estimate', label: '입찰견적'},
        {value: 'commerce', label: '컨텐츠다운로드주문'},
        {value: 'outlink', label: '아웃링크'},
        {value: 'counsel', label: '상담신청'},
        {value: 'meet', label: '모임신청'},
        {value: 'group', label: '팀그룹'},
        {value: 'delivery', label: '상품배송주문'},
        {value: 'reservation', label: '서비스 예약'},
        {value: 'booking', label: '숙박 예약'},
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: "전체", value: "all" },
        { label: "서비스명", value: "service_name" },
        { label: "서비스키", value: "key" },
        { label: "회원명", value: "name" },
        { label: "이메일", value: "email" },
      ]
    }
  ],

  // Launchpack
  launchpack_service_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['index', 'index', 65],
    ['service_name', '서비스명', 150],
    ['service_type', '서비스 구분', 120],
    ['packages', '서비스팩', 130],
    /*['kor_plugins', '플러그인', 120],
    ['addition_service', '부가서비스', 120],*/
    ['contract_date', '계약일', 120],
    ['service_date', '서비스이용 시작일', 120],
    ['service_user', '사용자 정보', 190],
    ['pay_type', '결제 방법', 280],
    /*['pay_once', '단건 결제', 110],*/
    // ['pay_recent', '최근 결제', 110],
    ['domain', '연결된 도메인', 130],
    ['status', '이용 상태', 120],
    /*['terminate', '서비스 해지', 200],
    ['modify_delete', '수정/삭제', 180]*/
    // ['key', '서비스키', 100],
    //['next_date', '다음 결제일', 120],
    //['pay_price', '금액', 120],
  ]),

  launchpack_service_utilize_filter_data: [
    {
      title: '기간',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '제공 서비스 구분',
      type: 'dropdown',
      key: 'category',
      value: null,
      options:[]
    },
    {
      title: '결제수단 구분',
      type: 'checkbox',
      key: 'pay_method',
      value: [],
      options:[]
    },
    {
      title: '납부 상태',
      type: 'radiobutton',
      key: 'status',
      value: null,
      options:[]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: "전체", value: "all" },
        { label: "상품 내용", value: "product_content" },
      ]
    }
  ],

  launchpack_service_utilize_table_data: sm.tableData([
    ['created_time', '등록일', 120],
    ['category_name', '제공 서비스 구분', 120],
    ['product_name', '상품 내용', 180],
    ['product_price', '상품 이용 금액', 100],
    ['pay_method', '결제 수단', 90],
    ['account_price', '결제(입금)액', 100],
    ['billing_status', '청구상태', 120],
    ['billing_date', '청구일', 120],
    ['taxbill_date', '세금계산서 발행일', 120],
    ['status', '납부 상태', 90],
    ['account_date', '결제일시', 100],
    ['invoice_date', 'invoice 발송일', 100],
    ['update', '수정/삭제', 80],
  ]),

  service_utilize_filter_data: [
    {
      title: '기간',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '제공 서비스 구분',
      type: 'dropdown',
      key: 'category',
      value: null,
      options:[]
    },
    {
      title: '결제수단 구분',
      type: 'checkbox',
      key: 'pay_method',
      value: [],
      options:[]
    },
    {
      title: '납부 상태',
      type: 'radiobutton',
      key: 'status',
      value: null,
      options:[]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: "전체", value: "all" },
        { label: "상품 내용", value: "product_content" },
      ]
    }
  ],

  service_utilize_table_data: sm.tableData([
    ['billing_date', '청구일', 120],
    ['category_name', '제공 서비스 구분', 120],
    ['product_name', '상품 내용', 180],
    ['product_price', '상품 이용 금액', 100],
    ['account_price', '결제(입금)액', 100],
    ['pay_method', '결제 수단', 90],
    ['status', '납부 상태', 90],
    ['account_date', '결제일시', 100]
  ]),

  launchpack_service_utilize_all_filter_data: [
    {
      title: '기간',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '제공 서비스 구분',
      type: 'dropdown',
      key: 'category',
      value: null,
      options:[]
    },
    {
      title: '결제수단 구분',
      type: 'checkbox',
      key: 'pay_method',
      value: [],
      options:[]
    },
    {
      title: '납부 상태',
      type: 'radiobutton',
      key: 'status',
      value: null,
      options:[]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: "전체", value: "all" },
        { label: "상품 내용", value: "product_content" },
        { label: "서비스명", value: "service_name" },
      ]
    }
  ],

  launchpack_service_utilize_all_table_data: sm.tableData([
    ['created_time', '등록일', 120],
    ['service_name', '서비스명', 120],
    ['end_date', '종료예정일', 120],
    ['category_name', '제공 서비스 구분', 120],
    ['product_name', '상품 내용', 180],
    ['product_price', '상품 이용 금액', 100],
    ['pay_method', '결제 수단', 90],
    ['account_price', '결제(입금)액', 100],
    ['billing_status', '청구상태', 120],
    ['billing_date', '청구일', 120],
    ['taxbill_date', '세금계산서 발행일', 120],
    ['status', '납부 상태', 90],
    ['account_date', '결제일', 100],
    ['invoice_date', 'invoice 발송일', 100],
    ['update', '수정/삭제', 80],
  ]),

  // 서비스 버전
  launchpack_service_version_table_data: sm.tableData([
    ['checkspot', '', 50],
    // ['index', 'index', 65],
    ['service_name', '서비스명', 150],
    ['status', '상태', 90],
    ['version_office', '백오피스 버전', 125],
    // ['menu', '메뉴관리', 100],
    ['log', '로그관리', 100],
    ['ui_updated_time', '서비스 업데이트 날짜', 170]
  ]),

  // 공지사항 목록
  launchpack_notice_filter_data: [
    {
      title: '게시글 작성일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: "전체", value: "" },
        { label: "서비스명", value: "service_name" },
        { label: "내용", value: "content" }
      ]
    }
  ],

  launchpack_notice_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '게시글 작성일', 130],
    ['title', '제목', 130],
    ['hits', '조회수', 85],
    ['modify_delete', '상세', 230]
  ]),

  // 내부 플러그인
  launchpack_internal_plugin_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '생성일', 120],
    ['key', 'key', 100],
    ['name', '이름', 120],
    ['use_type', '사용 구분', 120],
    ['modify_delete', '수정', 125]
  ]),

  // 1:1문의 - 전체내역
  launchpack_onetoone_filter_data: [
    {
      title: '작성일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '문의 카테고리',
      type: 'one_category',
    },
    {
      title: '답변여부',
      type: 'radiobutton',
      key: 'is_answered',
      value: null,
      options:[
        { label: '전체', value:null },
        { label: "완료", value: "true" },
        { label: "대기", value: "false" }
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: "전체", value: "all" },
        { label: "제목", value: "title" },
        { label: "질문내용", value: "content" },
        { label: "답변내용", value: "answer_content" },
        { label: "작성자이름", value: "name" },
        { label: "전화번호", value: "phone" },
        { label: "이메일", value: "email" },
      ]
    },
  ],

  launchpack_onetoone_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '문의작성일', 120],
    ['channel', '서비스 구분', 120],
    ['type', '문의유형', 104],
    ['name', '작성자', 80],
    ['title', '제목', 140],
    ['content', '내용', 140],
    ['status', '현재 상태', 100],
    ['status_button', '상태 변경', 120],
    ['answer_content', '답변 내용', 200],
    ['comment_status', '답변 상태', 120]
  ]),

  // 서비스 고객 문의
  customer_inquiry_filter_data: [
    {
      title: '작성일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '문의 유형',
      type: 'inquiry_category',
    },
    {
      title: '게시물 확인상태',
      type: 'radiobutton',
      key: 'is_new',
      value: null,
      options:[
        { label: '전체', value:null },
        { label: "확인", value: "true" },
        { label: "미확인", value: "false" }
      ]
    },
    {
      title: '답변여부',
      type: 'radiobutton',
      key: 'is_answered',
      value: null,
      options:[
        { label: '전체', value:null },
        { label: "완료", value: "true" },
        { label: "대기", value: "false" }
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: "전체", value: "all" },
        { label: "제목", value: "title" },
        { label: "질문내용", value: "content" },
        { label: "답변내용", value: "answer_content" }
      ]
    },
  ],

  customer_inquiry_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '문의 작성일', 120],
    ['cat', '문의유형', 100],
    ['title', '제목', 140],
    ['status', '처리 상태', 100],
    ['comment_status', '답변 상태', 140],
    ['is_new', '읽음 여부', 100]
  ]),

  // 서비스 고객 문의
  launchpack_customer_inquiry_filter_data: [
    {
      title: '작성일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '문의 유형',
      type: 'inquiry_category',
    },
    {
      title: '처리 상태',
      type: 'status'
    },
    {
      title: '게시물 확인상태',
      type: 'radiobutton',
      key: 'is_new',
      value: null,
      options:[
        { label: '전체', value:null },
        { label: "확인", value: "true" },
        { label: "미확인", value: "false" }
      ]
    },
    {
      title: '답변여부',
      type: 'radiobutton',
      key: 'is_answered',
      value: null,
      options:[
        { label: '전체', value:null },
        { label: "완료", value: "true" },
        { label: "대기", value: "false" }
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: "전체", value: "all" },
        { label: "제목", value: "title" },
        { label: "질문내용", value: "content" },
        { label: "답변내용", value: "answer_content" }
      ]
    },
  ],

  launchpack_customer_inquiry_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '문의작성일', 120],
    ['comments', '댓글 수', 85],
    ['answer_time', '최근 댓글 시간', 130],
    ['service_name', '서비스명', 120],
    ['cat', '문의유형', 100],
    ['title', '제목', 140],
    ['status', '처리 상태', 120],
    ['comment_status', '답변 상태', 150],
    ['is_new', '고객 답변 확인', 130]

  ]),

  // 서비스 고객 문의
  launchpack_template_inquiry_filter_data: [
    {
      title: '제안일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '진행상태',
      type: 'radiobutton',
      key: 'status',
      value: null,
      options:[
        { label: '전체', value:null },
        { label: "미확인", value: 0 },
        { label: "진행중", value: 1 },
        { label: "보류", value: 2 },
        { label: "진행 안함", value: 3 },
        { label: "진행 완료", value: 4 }
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: "전체", value: "all" },
        { label: "제안제목", value: "title" },
        { label: "제안내용", value: "content" },
        { label: "제안자", value: "user" }
      ]
    },
  ],

  launchpack_template_inquiry_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '제안일', 130],
    ['status', '진행 상태', 85],
    ['user', '제안자 정보', 150],
    ['title', '제안 제목', 200],
    ['content', '제안 내용', 120]
  ]),

  // 퀵빌더 설문
  launchpack_builder_survey_filter_data: [
    {
      title: '설문일',
      type: 'period',
      start: '',
      end: ''
    },
    /*{
      title: '경로',
      type: 'checkbox',
      key: 'route',
      value: ['SNS','블로그','네이버 지식인','지인소개','인터넷 검색'],
      options: [
        {label: 'SNS', value: 'SNS'},
        {label: '블로그', value: '블로그'},
        {label: '네이버 지식인', value: '네이버 지식인'},
        {label: '지인소개', value: '지인소개'},
        {label: '인터넷 검색', value: '인터넷 검색'}
      ]
    },
    {
      title: '검색포털',
      type: 'checkbox',
      key: 'portal',
      value: ['네이버','다음','네이트','구글','기타'],
      options: [
        {label: '네이버', value: '네이버'},
        {label: '다음', value: '다음'},
        {label: '네이트', value: '네이트'},
        {label: '구글', value: '구글'},
        {label: '기타', value: '기타'}
      ]
    }*/
  ],

  launchpack_builder_survey_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '설문일', 130],
    ['route', '경로', 120],
    ['portal', '검색 포털', 120],
    ['keyword', '검색 키워드', 120],
    ['name', '회원명', 120],
    ['email', '이메일', 120],
    ['phone', '휴대 전화 번호', 150]
  ]),

  launchpack_sms_send_point_table_data: sm.tableData([
    ['name', '키값(영어명)', 85],
    ['kor_name', '제목(한글명)', 85],
    ['package', '상품종류', 85],
    ['enable', '활성화여부', 85],
    ['modify_delete', '수정', 120]
  ]),

  launchpack_management_fee_add_filter_data: [
    {
      title: '주문일자',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '금액',
      type: 'price',
      list: [
        {
          key: 'min_price',
          value: ''
        },
        {
          key: 'max_price',
          value: ''
        }
      ]
    },
  ],
  launchpack_management_fee_add_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '충전일', 200],
    ['price', '충전금액', 200],
    ['service_name', '서비스명', 200],
    ['pay_type', '결제방식', 200],
    ['card_bill_info', '결제정보', 240]
  ]),

  launchpack_orderproduct_filter_data: [
    {
      title: '주문일자',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '금액',
      type: 'price',
      list: [
        {
          key: 'min_price',
          value: ''
        },
        {
          key: 'max_price',
          value: ''
        }
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: "전체", value: "all" },
        { label: "주문명", value: "order_name" },
        { label: "주문내용", value: "item_name" }
      ]
    }
  ],
  launchpack_orderproduct_table_data: sm.tableData([
    ['created_time', '결제일', 200],
    ['service_name', '서비스명', 200],
    ['order_name', '주문명', 200],
    ['id', '품목 주문번호', 200],
    ['item_name', '주문내용', 200],
    ['price', '차감금액', 200],
    ['status_kor', '진행상태', 200]
  ]),

  send_message_template_table_data: sm.tableData([
    ['name', '전송시점', 85],
    ['target', '대상', 85],
    ['modify_delete', '수정/삭제', 125]
  ]),

  // 결제 내역
  bill_payment_filter_data: [
    {
      title: '처리일시',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '결제금액',
      type: 'price',
      list: [
        {
          key: 'min_price',
          value: ''
        },
        {
          key: 'max_price',
          value: ''
        }
      ]
    },
    /*{
      title: '구분',
      type: 'radiobutton',
      key: 'is_cancel',
      options:[
        {label: '전체', value:''},
        {label: '결제취소', value:'true'},
        {label: '결제완료', value:'false'}
      ]
    },*/
    {
      title: '결제 조회',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '서비스명', value: 'service_name' },
        { label: '결제자', value: 'name' }
      ]
    }
  ],

  bill_payment_table_data: sm.tableData([
    ['index', 'index', 65],
    ['status', '구분', 80],
    ['pay_status', '결제종류', 120],
    ['created_time', '날짜', 120],
    ['title', '상품명', 120],
    ['price', '금액', 100],
    ['service_name', '서비스명', 120],
    ['bill', '카드정보', 170],
    ['name', '결제자', 120],
    ['is_cancel', '결제취소처리', 170]
  ]),

  my_bill_payment_table_data: sm.tableData([
    ['index', 'index', 65],
    ['status', '구분', 80],
    ['pay_status', '결제종류', 120],
    ['created_time', '날짜', 120],
    ['title', '상품명', 120],
    ['price', '금액', 100],
    ['name', '결제자', 120],
    ['is_cancel', '구분', 170],
    ['detail', '상세', 150]
  ]),

  service_inquiry_filter_data: [
    {
      title: '처리일시',
      type: 'period',
      start: '',
      end: ''
    }
  ],

  // 맞춤 제작 신청
  service_inquiry_table_data: sm.tableData([
    ['id', 'id', 65],
    ['created_time', '날짜', 120],
    ['channel', '문의 경로', 120],
    ['name', '신청자명', 100],
    // ['email', '이메일', 150],
    ['phone', '휴대전화번호', 120],
    ['service_name', '서비스 이름', 120],
    // ['content', '서비스 내용', 120],
    // ['hope_date', '소요기간', 80],
    // ['service_status', '서비스 등록', 100],
    ['status_action', '처리', 120],
    ['new', '새 메시지', 80],
    ['all', '전체 메시지', 80],
    ['modify_delete', '상세', 140]
  ]),

  theme_request_filter_data: [
    {
      title: '처리일시',
      type: 'period',
      start: '',
      end: ''
    }
  ],

  // 테마 이용 신청
  theme_request_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '날짜', 120],
    ['inquiry_type', '문의 타입', 120],
    ['product_name', '상품 이름', 120],
    ['theme_name', '테마 이름', 120],
    ['name', '신청자 이름', 120],
    ['service_id', '서비스 아이디', 130],
    ['service_name', '서비스 이름', 120],
    ['email', '이메일', 120],
    ['phone', '휴대전화번호', 150],
    ['counsel', '상담 가능시간', 150],
    ['price', '요금', 100],
    ['type', '타입', 120],
    ['service_status', '서비스 등록 여부', 150],
    ['status', '상태', 120],
    ['status_action', '처리', 130],
    ['modify_delete', '상세', 130]
  ]),

  // 주문
  purchase_filter_data: [
    {
      title: '기간검색',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' }
      ]
    }
  ],

  purchase_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['index', '번호', 50],
    ['index', '주문번호', 120],
    ['created_time', '날짜', 120],
    ['order', '주문자', 80],
    ['product', '주문 상품', 240],
    ['product_price', '상품금액', 100],
    ['delivery_price', '배송비', 100],
    ['discount_price', '할인금액', 100],
    ['total_price', '총 주문금액', 110],
    ['pay_type', '결제방법', 100]
  ]),

  // 주문
  purchase_product_filter_data: [
    {
      title: '기간검색',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' }
      ]
    }
  ],

  purchase_product_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['index', '번호', 50],
    ['index', '상품 주문번호', 120],
    ['created_time', '날짜', 120],
    ['order', '주문자', 80],
    ['product', '주문 상품', 240],
    ['quantity', '수량', 50],
    ['product_price', '상품금액', 100],
    ['delivery_price', '배송비', 100],
    ['discount_price', '할인금액', 100],
    ['total_price', '총 주문금액', 100],
    ['partner', '파트너명', 100],
    ['pay_type', '결제방법', 100],
    ['status', '주문상태', 100],
    ['pay_status', '결제상태', 100],
  ]),
  purchase_detail_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['index', '번호', 50],
    ['index', '상품 주문번호', 120],
    ['created_time', '날짜', 120],
    ['name', '상품명', 80],
    ['quantity', '수량', 80],
    ['total_price', '총 주문금액', 100],
    ['invoice', '송장번호', 100],
    ['status', '주문상태', 80]
  ]),

  // 주문
  account_new_filter_data: [
    {
      title: '기간검색',
      type: 'period',
      start: '',
      end: ''
    }
  ],

  account_new_table_data: sm.tableData([
    ['partner_name', '파트너명', 120],
    ['created_time', '생성날짜', 120],
    ['expect_date', '정산 예상날짜', 140],
    ['min_price', '최소 금액', 120],
    ['total_price', '주문금액(A)', 120],
    ['comm_price', '수수료(B)', 100],
    ['coupon_price', '할인 부담 금액(C)', 150],
    ['point', '적립 공제 금액(D)', 150],
    ['acc_price', '정산할 금액', 120],
    ['history', '판매내역', 120],
    ['modify_delete', '완료', 120]
  ]),

  // 주문
  account_all_filter_data: [
    {
      title: '기간검색',
      type: 'period',
      start: '',
      end: ''
    }
  ],

  account_all_table_data: sm.tableData([
    ['acc_date', '정산날짜', 120],
    ['partner_name', '파트너명', 120],
    ['total_price', '주문금액(A)', 120],
    ['comm_price', '수수료(B)', 100],
    ['coupon_price', '할인 부담 금액(C)', 150],
    ['point', '적립 공제 금액(D)', 150],
    ['acc_price', '정산된 금액', 120],
    ['history', '판매내역', 140]
  ]),
  nopass_table_data: sm.tableData([
    ['index', '번호', 100],
    ['created_time', '날짜', 120],
    ['bank', '은행명', 80],
    ['account_number', '계좌번호', 120],
    ['name', '이름', 100],
    ['enable_use', '사용여부', 80],
    ['partner', '파트너', 80],
    ['modify_delete', '수정', 120]
  ]),

  // 주문
  outlink_filter_data: [
    {
      title: '회원 구분',
      type: 'radiobutton',
      key: 'is_user',
      value: null,
      options:[
        { label: '전체', value:null },
        {label: '비회원', value:'false'},
        {label: '회원', value:'true'}
      ]
    },
    {
      title: '조회기간',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '카테고리',
      type: 'category',
      options: {
        category1: [],
        category2: [],
        category3: []
      }
    },
    {
      title: '링크 성공여부',
      type: 'radiobutton',
      key: 'is_success',
      value: null,
      options:[
        { label: '전체', value:null },
        {label: '성공', value:'true'},
        {label: '실패', value:'false'}
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '파트너명', value: 'partner' },
        { label: '회원명', value: 'user' },
        { label: '상품id', value: 'product' }
      ]
    }
  ],

  outlink_table_data: sm.tableData([
    ['index', '번호', 100],
    ['created_time', '아웃링크 시점', 150],
    ['is_user', '회원여부', 120],
    ['user_name', '회원명', 120],
    ['partner_name', '파트너명', 100],
    ['product_name', '상품명', 100],
    ['img', '상품 대표 이미지', 150],
    ['link', '아웃링크 URL', 130],
    ['is_success', '링크 성공 여부', 130]
  ]),

  // 신규 상담 신청 내역
  counsel_request_filter_data: [
    {
      title: '상태값',
      type: 'radiobutton',
      key: 'status',
      value: null,
      options:[
        { label: '전체', value:null },
        {label: '신청대기', value:0},
        {label: '신청확인', value:1},
        {label: '참여승인', value:2},
        {label: '주문완료', value:3},
        {label: '참여거부', value:101}
      ]
    },
    {
      title: '견적요청일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '상담신청 폼',
      key: 'counsel_form',
      type: 'dropdown',
      options: []
    },
    /*{
      title: '카테고리',
      type: 'category',
      options: {
        category1: [],
        category2: [],
        category3: []
      }
    },*/
    {
      title: '통합검색',
      type: 'search',
      options: [
        {label: '전체', value: 'all'},
        {label: '회원명', value: 'user'},
        {label: '파트너명', value: 'partner'},
        {label: '상품명', value: 'product'},
        {label: '신청자명', value: 'name'},
        {label: '신청자 전화번호', value: 'phone'},
        {label: '신청자 이메일', value: 'email'}
      ]
    }
  ],

  counsel_request_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '주문 전환 시점', 150],
    ['is_user', '회원여부', 100],
    ['user_name', '회원명', 100],
    ['category', '카테고리', 100],
    ['partner_name', '파트너명', 100],
    ['product', '상품ID', 100],
    ['img', '상품 대표 이미지', 100],
    ['product_name', '상품명', 100],
    ['counsel_content', '상담 신청 내용', 100],
    ['request_status', '신청 확인 여부', 130],
    ['deposit_status', '입금 확인 여부', 130],
    ['counsel_status', '상담 진행 여부', 130],
    ['order_status', '주문여부', 130],
  ]),

  // 모임 참여 내역
  meet_request_filter_data: [
    {
      title: '상태값',
      type: 'radiobutton',
      key: 'status',
      value: null,
      options:[
        { label: '전체', value:null },
        {label: '승인대기', value:0},
        {label: '신청확인', value:1},
        {label: '입금확인', value:2},
        {label: '참여승인', value:3},
        {label: '신청거절', value:101},
        {label: '취소', value: 102},
        {label: '참여취소', value: 103},
        {label: '환불완료', value: 104},
        {label: '환불없음', value: 105}
      ]
    },
    {
      title: '신청일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '신청 폼',
      key: 'meet_form',
      type: 'dropdown',
      options: []
    },
    /*{
      title: '카테고리',
      type: 'category',
      options: {
        category1: [],
        category2: [],
        category3: []
      }
    },*/
    {
      title: '통합검색',
      type: 'search',
      options: [
        {label: '전체', value: 'all'},
        {label: '회원명', value: 'user'},
        {label: '파트너명', value: 'partner'},
        {label: '상품명', value: 'product'},
        {label: '신청자 이름', value: 'name'},
        {label: '신청자 전화번호', value: 'phone'},
        {label: '신청자 이메일', value: 'email'}
      ]
    }
  ],

  meet_request_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '주문 전환 시점', 150],
    ['is_user', '회원여부', 100],
    ['user_name', '회원명', 100],
    ['category', '카테고리', 100],
    ['partner_name', '파트너명', 100],
    ['order_num', '주문번호', 120],
    ['img', '상품 대표 이미지', 100],
    ['product_name', '상품명', 100],
    ['forms', '참여 내용', 240],
    ['name', '이름', 80],
    ['phone', '연락처', 120],
    ['email', '이메일', 120],
    ['pay_type_kor', '결제수단', 100],
    ['request_status', '신청 확인 여부', 150],
    ['deposit_status', '입금 확인 여부', 150],
    ['meet_status', '참여 진행 여부', 150],
    ['refund_status', '환불', 120],
    ['modify_delete', '삭제', 120],
  ]),

  group_album_filter_data: [
    {
      title: '팀 선택',
      type: 'group_category',
    },
    {
      title: '조회기간',
      type: 'period',
      start: '',
      end: ''
    },

    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '앨범명', value: 'title' },
        { label: '팀명', value: 'group' },
        { label: '회원명', value: 'name' }
      ]
    }
  ],

  group_album_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '생성일', 120],
    ['group_name', '팀명', 100],
    ['name', '앨범명', 120],
    ['display_name', '작성자', 100],
    ['modify_delete', '수정', 125]
  ]),

  group_album_post_filter_data: [
    {
      title: '팀 선택',
      type: 'group_category',
    },
    {
      title: '조회기간',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '제목', value: 'title' },
        { label: '내용', value: 'content' }
      ]
    }
  ],

  group_album_post_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '생성일', 120],
    ['group_name', '팀명', 100],
    // ['album_name', '앨범명', 120],
    ['title', '게시물 제목', 120],
    ['display_name', '작성자', 100],
    ['modify_delete', '수정', 125]
  ]),

  // 팀노트 목록
  group_board_filter_data: [
    {
      title: '팀 선택',
      type: 'group_category',
    },
    {
      title: '조회기간',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '팀노트명', value: 'name' },
        { label: '팀명', value: 'group' },
        { label: '회원명', value: 'user' }
      ]
    }
  ],

  group_board_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '생성일', 120],
    ['group_name', '팀명', 100],
    ['name', '팀노트명', 120],
    ['display_name', '작성자', 100],
    ['modify_delete', '수정', 125]
  ]),

  group_board_base_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '생성일', 120],
    ['name', '팀노트명', 120],
    ['modify_delete', '수정', 125]
  ]),

  group_calendar_filter_data: [
    {
      title: '팀 선택',
      type: 'group_category',
    },
    {
      title: '해당일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: "전체", value: "all" },
        { label: "제목", value: "title" },
        { label: "내용", value: "content" }
      ]
    }
  ],
  group_calendar_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '생성일', 120],
    ['group_name', '팀명', 100],
    ['title', '제목', 120],
    ['start', '시작일', 80],
    ['end', '종료일', 80],
    ['display_name', '작성자', 100],
    ['modify_delete', '수정', 125]
  ]),

  group_duty_filter_data: [
    {
      title: '팀 선택',
      type: 'group_category',
    },
    {
      title: '조회기간',
      type: 'period',
      start: '',
      end: ''
    }
  ],

  group_duty_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '생성일', 120],
    ['group_name', '팀명', 100],
    ['img', '업로드한 파일', 125],
    ['display_name', '작성자', 100],
    ['modify_delete', '삭제', 125]
  ]),

  // 공지사항 목록
  group_notice_filter_data: [
    {
      title: '팀 선택',
      type: 'group_category',
    },
    {
      title: '게시글 작성일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: "전체", value: "all" },
        { label: "제목", value: "title" },
        { label: "내용", value: "content" }
      ]
    }
  ],

  group_notice_table_data: sm.tableData([
    ['index', 'index', 60],
    ['created_time', '작성일', 80],
    ['group_name', '팀명', 80],
    // ['category', '카테고리', 100],
    ['title', '제목', 140],
    ['hits', '조회수', 80],
    ['modify_delete', '수정/삭제', 125]
  ]),

  group_post_filter_data: [
    {
      title: '조회기간',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '제목', value: 'title' },
        { label: '내용', value: 'content' }
      ]
    }
  ],

  group_post_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '생성일', 120],
    ['board_name', '팀노트명', 120],
    ['title', '노트 제목', 120],
    ['display_name', '작성자', 100],
    ['group_name', '팀명', 100],
    ['modify_delete', '수정', 125]
  ]),

  group_post_base_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '생성일', 120],
    ['board_name', '팀노트명', 120],
    ['hits', '조회수', 120],
    ['title', '노트 제목', 120],
    ['modify_delete', '수정', 125]
  ]),

  group_filter_data: [
    {
      title: '조회기간',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '팀 공개설정',
      type: 'radiobutton',
      key: 'type',
      value: null,
      options:[
        { label: '전체', value:null },
        {label: '공개', value:1},
        {label: '비공개', value:0}
      ]
    },
    {
      title: '가입신청 사용여부',
      type: 'radiobutton',
      key: 'enable_approval_sign',
      value: null,
      options:[
        { label: '전체', value:null },
        {label: '사용', value:true},
        {label: '사용안함', value:false}
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '팀명', value: 'name' },
        { label: '팀 소개글', value: 'simple_desc' }
      ]
    }
  ],

  group_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '생성일', 120],
    ['name', '팀명', 120],
    ['type', '팀 공개설정', 120],
    ['member', '팀 인원수', 100],
    ['simple_desc', '팀 소개글', 100],
    ['enable_approval_sign', '가입신청 사용여부', 100],
    ['modify_delete', '삭제', 125]
  ]),

  group_member_filter_data: [
    {
      title: '팀 선택',
      type: 'group_category',
    },
    {
      title: '조회기간',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '이름', value: 'name' },
        { label: '이메일', value: 'email' },
        { label: '휴대전화번호', value: 'phone' }
      ]
    }
  ],

  group_member_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '생성일', 120],
    ['auth', '권한', 100],
    ['group_name', '팀명', 120],
    ['name', '이름', 100],
    ['email', '이메일', 160],
    ['phone', '휴대전화번호', 120],
    ['manager', '매니저추가', 120],
    ['leader', '리더위임', 120],
    ['modify_delete', '탈퇴처리', 125]
  ]),

  // 슈퍼파트너
  super_partner_filter_data: [
    {
      title: '가입일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: sm.options([
        ['전체', 'all'],
        ['이름', 'name'],
        ['전화번호', 'phone'],
        ['아이디', 'username']
      ])
    }
  ],

  super_partner_table_data: sm.tableData([
    ['index', 'index', 68],
    ['created_time', '가입일', 120],
    ['name', '이름', 110],
    ['email', '아이디(이메일)', 180],
    ['phone', '휴대전화번호', 150],
    ['modify_delete', '수정/삭제', 125]
  ]),

  // 쿠폰
  coupon_filter_data: [
    {
      title: '등록일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: sm.options([
        ['전체', 'all']
      ])
    }
  ],

  coupon_table_data: sm.tableData([
    ['index', 'index', 68],
    ['created_time', '발급일', 120],
    ['name', '쿠폰명', 80],
    ['num', '쿠폰번호', 180],
    ['end_date', '종료날짜', 150],
    ['activate', '상태', 100],
    ['publish_count', '발행 현황', 100],
    ['burden_type', '할인 부담 유형', 140],
    ['discount', '할인', 100],
    ['type', '유형', 100],
    ['publish_status', '발행하기', 140],
    ['management', '발행내역관리', 150],
    ['modify_delete', '수정/삭제', 125]
  ]),

  // 쿠폰
  download_coupon_filter_data: [
    {
      title: '등록일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: sm.options([
        ['전체', 'all']
      ])
    }
  ],

  download_coupon_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['index', 'index', 68],
    ['created_time', '등록일', 120],
    ['name', '쿠폰명', 120],
    ['download_period', '다운로드 가능 기간', 160],
    ['activate', '상태', 80],
    ['burden_type', '할인 부담 유형', 120],
    ['discount', '할인', 120],
  ]),

  // 회원 목록
  user_coupon_filter_data: [
    {
      title: '가입일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '지역',
      type: 'region',
      options: {
        sido: [],
        sigungu: [],
        dong: []
      }
    },
    {
      title: '성별',
      key: 'gender',
      type: 'dropdown'
    },
    {
      title: '가입종류',
      key: 'joined_type',
      type: 'dropdown'
    },
    {
      title: '파트너 담당자 여부',
      type: 'radiobutton',
      key: 'is_normal',
      value: null,
      options:[
        { label: '전체', value:null },
        {label: '일반 회원', value:true},
        {label: '파트너 담당자', value:false}
      ]
    },
    {
      title: '회원등급',
      key: 'grade',
      type: 'dropdown',
      options: []
    },
    {
      title: '통합검색',
      type: 'search',
      options: sm.options([
        ['전체', 'all'],
        ['이름', 'name'],
        ['연락처', 'phone'],
        ['이메일', 'email'],
        ['아이디', 'username']
      ])
    }
  ],

  user_coupon_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['index', 'index', 68],
    ['created_time', '가입일', 120],
    ['name', '회원명', 100],
    ['phone', '휴대전화번호', 130],
    ['email', '이메일', 180],
    ['gender', '성별', 75],
  ]),

  // 발급 내역
  user_coupon_issue_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['index', 'index', 68],
    ['created_time', '발급일', 120],
    ['enable_use', '사용여부', 100],
    ['partner', '파트너 담당자', 130],
    ['name', '회원명', 100],
    ['phone', '휴대전화번호', 130],
    ['email', '이메일', 180],
    ['gender', '성별', 75]
  ]),

  // 발급 내역
  user_coupon_issue_filter_data: [
    {
      title: '가입일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '지역',
      type: 'region',
      options: {
        sido: [],
        sigungu: [],
        dong: []
      }
    },
    {
      title: '성별',
      key: 'gender',
      type: 'dropdown'
    },
    {
      title: '가입종류',
      key: 'joined_type',
      type: 'dropdown'
    },
    {
      title: '파트너 담당자 여부',
      type: 'radiobutton',
      key: 'is_normal',
      value: null,
      options:[
        { label: '전체', value:null },
        {label: '일반 회원', value:true},
        {label: '파트너 담당자', value:false}
      ]
    },
    {
      title: '회원등급',
      key: 'grade',
      type: 'dropdown',
      options: []
    },
    {
      title: '통합검색',
      type: 'search',
      options: sm.options([
        ['전체', 'all'],
        ['이름', 'name'],
        ['연락처', 'phone'],
        ['이메일', 'email'],
        ['아이디', 'username']
      ])
    }
  ],

  // 배송비 조건
  deliveryprice_filter_data: [
    {
      title: '등록일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: sm.options([
        ['전체', 'all']
      ])
    }
  ],

  deliveryprice_table_data: sm.tableData([
    ['index', 'index', 68],
    ['created_time', '생성일', 120],
    ['name', '조건명', 130],
    ['desc', '간단설명', 180],
    ['delivery_method', '배송비 방식', 120],
    ['delivery_type', '배송비 유형', 110],
    ['tax_method', '배송비 부과 방법', 140],
    ['pay_type', '배송비 결제 방법', 140],
    ['modify_delete', '수정/삭제', 125]
  ]),

  partner_approve_new_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['index', 'index', 68],
    ['created_time', '생성일', 120],
    ['approval_status', '승인구분', 100],
    ['name', '회원명', 100],
    ['username', '회원이메일(아이디)', 140],
    ['phone', '전화번호', 100],
    ['grade', '회원등급', 100],
    ['content', '파트너내용', 100],
    ['approval', '승인처리', 125]
  ]),

  partner_approve_all_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['index', 'index', 68],
    ['created_time', '생성일', 120],
    ['approval_status', '승인구분', 100],
    ['name', '회원명', 100],
    ['username', '회원이메일(아이디)', 140],
    ['phone', '전화번호', 100],
    ['grade', '회원등급', 100],
    ['content', '파트너내용', 100]
  ]),

  // 수퍼바이저 목록
  supervisor_filter_data: [
    {
      title: '등록일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        {label: '전체', value: 'all'}
      ]
    }
  ],

  supervisor_table_data: sm.tableData(
    [
      ['checkspot', '', 50],
      ['index', 'index', 65],
      ['name', '슈퍼바이저명', 140],
      ['username', '아이디', 140],
      ['phone', '휴대전화번호', 140],
      ['partners_count', '소속된 파트너 수', 150],
      ['created_time', '등록일', 120]
    ]
  ),

  supervisors_partner_table_data: sm.tableData(
    [
      ['checkspot', '', 50],
      ['index', 'index', 65],
      ['name', '파트너명', 100],
      ['phone', '대표 전화번호', 140],
      ['username', '대표 관리자 아이디', 120]
    ]
  ),

  // 신규 예
  mart_product_table_data: sm.tableData([
    ['index', 'index', 65],
    ['partner_name', '파트너명', 120],
    ['stock', '재고', 300],
    ['ordered_count', '주문수', 300]
  ]),
  // 서비스 가이드
  email_send_filter_data: [
    {
      title: '기간 검색',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '전송 대상',
      type: 'radiobutton',
      key: 'target',
      value: null,
      options:[
        { label: '전체', value: null },
        { label: '일반회원', value: 0 },
        { label: '마케팅 수신 회원', value: 2 }
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: "전체", value: "all" },
        { label: "제목", value: "title" },
        { label: "내용", value: "content" },
      ]
    }
  ],
  email_send_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '전송일', 140],
    ['title', '제목', 140],
    ['target', '전송대상', 80],
    ['send_count', '전송건수', 80]
  ]),
  // 서비스 가이드
  sms_send_filter_data: [
    {
      title: '기간 검색',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '전송 대상',
      type: 'radiobutton',
      key: 'target',
      value: null,
      options:[
        { label: '전체', value: null },
        { label: '일반회원', value: 0 },
        { label: '마케팅 수신 회원', value: 2 }
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: "전체", value: "all" },
        { label: "내용", value: "msg" },
      ]
    }
  ],
  sms_send_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '전송일', 140],
    ['msg', '내용', 140],
    ['target', '전송대상', 80],
    ['send_count', '전송건수', 80]
  ]),
  qa_sheet_filter_data: [
    {
      title: '검색',
      type: 'search',
      options: [
        { label: "전체", value: "all" },
        { label: "요청 내용", value: "req_content" },
      ]
    },
    {
      type: 'user'
    }
  ],
  qa_sheet_table_data: sm.tableData([
    ['created_time', '작성일', 120],
    ['ftype', '구분', 120],
    ['location', '위치', 120],
    ['result', '기대결과', 120],
    ['req_content', '요청 내용', 120],
    ['priority', '우선순위', 120],
    ['comment', '댓글 수', 120],
    ['req_user_name', '요청자', 80],
    ['task_user_name', '담당자', 80],
    ['task_end_date', '작업 완료', 100],
    ['req_check_date', '요청자 확인', 120]
  ]),
  qa_improve_filter_data: [
    {
      title: '검색',
      type: 'search',
      options: [
        { label: "전체", value: "all" },
        { label: "요청 내용", value: "req_content" },
      ]
    },
    {
      type: 'user'
    }
  ],
  qa_improve_table_data: sm.tableData([
    ['created_time', '작성일', 120],
    ['ftype', '구분', 120],
    ['location', '위치', 120],
    ['result', '기대결과', 120],
    ['req_content', '요청 내용', 120],
    ['req_user_name', '요청자', 80],
    ['status', '진행상황', 80],
  ]),

  // 서비스 플랜 목록
  launchpack_service_plan_filter_data: [
    {
      title: '통합검색',
      type: 'search',
      options: sm.options([
        ['전체', 'all'],
        ['멤버쉽', 'membership'],
      ])
    },
  ],

  launchpack_service_plan_table_data: sm.tableData([
    ['membership', '멤버쉽', 100],
    ['usage', '이용량', 150],
    ['modify_delete', '수정/삭제', 125]
  ]),

  // 서비스 플랜 목록
  launchpack_service_plan_management_filter_data: [
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '서비스명', value: 'service_name' }
      ]
    }
  ],

  launchpack_service_plan_management_table_data: sm.tableData([
    ['index', 'index', 65],
    ['service_name', '서비스명', 150],
    ['usage', '이용량', 150]
  ]),

  // 서비스 플랜 목록
  launchpack_service_app_order_request_filter_data: [
    {
      title: '서비스 생성일',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '서비스 구분',
      type: 'radiobutton',
      key: 'app_type',
      value: null,
      options:[
        {value: null, label: '전체'},
        {value: 'plugin', label: '플러그인'},
        {value: 'service', label: '추가서비스'}
      ]
    },
    {
      title: '서비스 상태',
      type: 'radiobutton',
      key: 'status',
      value: null,
      options:[
        {value: null, label: '전체'},
        {value: 0, label: '이용 예정'},
        {value: 9, label: '이용중'},
        {value: 10, label: '관리자 정지'},
        {value: 99, label: '전체정지'},
        {value: 100, label: '이용중단'}
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: "전체", value: "all" },
        { label: "서비스명", value: "service_name" },
        { label: "이메일", value: "email" }
      ]
    }
  ],

  launchpack_service_app_order_request_table_data: sm.tableData([
    ['index', 'index', 65],
    ['service_name', '서비스명', 150],
    ['app_type_kor', '구분', 120],
    ['product_name', '신청 기능', 130],
    ['is_subscription', '선택 옵션', 120],
    ['status', '이용 상태', 120],
    ['created_time', '신청일', 120],
    ['start_date', '이용 시작일', 120],
    ['service_user', '사용자 정보', 180]
  ]),

  skin_inquiry_filter_data: [
    {
      title: '신청일자',
      type: 'period',
      start: '',
      end: ''
    }
  ],

  // 스킨 수정 요청
  // 신청일자, 신청자, 서비스명, 카테고리, 요청사항, 상태
  skin_inquiry_table_data: sm.tableData([
    ['index', 'index', 65],
    ['created_time', '신청일자', 80],
    ['name', '신청자명', 60],
    ['email', '이메일', 120],
    ['service_name', '서비스명', 100],
    ['category', '문의유형', 90],
    ['content', '요청사항', 150],
    ['status_kor', '상태', 80],
    ['modify', '상세', 80]
  ]),

  templates_order_filter_data: [
    {
      title: '주문일자',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' }
      ]
    },

  ],

  templates_order_table_data: sm.tableData([
    ['created_time', '주문일시', 120],
    ['user_name', '주문자', 80],
    ['order_num', '주문번호', 130],
    ['partner', '파트너', 120],
    ['order_product', '주문 상품', 240],
    ['total_price', '결제금액', 100],
    ['pay_type', '결제수단', 100],
    ['pay_day', '결제일시', 100]
  ]),


  source_inquiry_filter_data: [
    {
      title: '신청날짜',
      type: 'period',
      start: '',
      end: ''
    }
  ],

  source_inquiry_table_data: sm.tableData([
    ['id', 'ID', 120],
    ['status', '상태', 120],
    ['category', '파일 카테고리', 120],
    ['title', '제목', 120],
    ['name', '신청자명', 120],
    ['created_time', '신청날짜', 120],
  ]),

  receipts_filter_data: [
    {
      title: '입고일자',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: sm.options([
        ['전체', 'all'],
        ['이름', 'name'],
        ['수취인', 'receipt_name'],
        ['트래킹 번호', 'tracking_no'],
        ['신청번호', 'reference_no'],
        ['특이사항', 'memo']
      ])
    },
  ],

  receipts_table_data: sm.tableData([
    ['checkspot', '', 50, false],
    ['index', 'index', 68, false],
    ['receipt_time', '입고일자', 120, false],
    ['name', '이름', 80, false],
    ['receipt_name', '수취인', 80, false],
    ['tracking_no', '트래킹번호', 120, false],
    ['reference_no', '신청번호', 120, false],
    ['memo', '특이사항', 200, false],
    ['act_weight', '실측무게', 80, false],
    ['width', '가로', 80, false],
    ['length', '세로', 80, false],
    ['height', '높이', 80, false],
    ['vol_weight', '부피무게', 80, false],
    ['claim_weight', '청구무게', 80, false],
    ['modify_delete', '수정/삭제', 125, false]
  ])
}
